// utils/processors/regularMediaProcessor.js

export class RegularMediaProcessor {
  static processRegularMedia(tempDiv) {
    // Regex patterns for different media types
    const imagePattern = /https?:\/\/[^\s]+\.(?:jpg|jpeg|png|gif|webp|svg|bmp|ico)(?:\?[^\s]*)?/gi;
    const videoPattern = /https?:\/\/[^\s]+\.(?:mp4|webm|ogg|mov|avi|wmv|flv|mkv)(?:\?[^\s]*)?/gi;
    const youtubePattern = /https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/gi;

    // Process non-list media (regular block content)
    const walker = document.createTreeWalker(
      tempDiv,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function(node) {
          // Skip nodes that are inside list items (already processed)
          if (node.parentNode.closest('li')) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      },
      false
    );

    const textNodes = [];
    let node;
    while (node = walker.nextNode()) {
      textNodes.push(node);
    }

    // Process each text node for URLs (non-list content)
    textNodes.forEach(textNode => {
      const text = textNode.textContent;
      let hasMedia = false;
      let newHTML = text;

      // Replace image URLs with block layout
      if (imagePattern.test(text)) {
        newHTML = newHTML.replace(imagePattern, (url) => {
          hasMedia = true;
          return RegularMediaProcessor.generateImageHTML(url);
        });
      }

      // Replace video URLs with block layout
      if (videoPattern.test(newHTML)) {
        newHTML = newHTML.replace(videoPattern, (url) => {
          hasMedia = true;
          return RegularMediaProcessor.generateVideoHTML(url);
        });
      }

      // Replace YouTube URLs with block layout
      if (youtubePattern.test(newHTML)) {
        newHTML = newHTML.replace(youtubePattern, (match, videoId) => {
          hasMedia = true;
          return RegularMediaProcessor.generateYouTubeHTML(videoId);
        });
      }

      // If we found media, replace the text node
      if (hasMedia) {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = newHTML;

        // Replace the text node with the new elements
        const parent = textNode.parentNode;
        while (wrapper.firstChild) {
          parent.insertBefore(wrapper.firstChild, textNode);
        }
        parent.removeChild(textNode);
      }
    });

    return tempDiv;
  }

  static generateImageHTML(url) {
    return `
      <div class="regular-media-container">
        <img src="${url}" alt="Image" class="regular-media-image" 
             onclick="window.open('${url}', '_blank')" />
      </div>
    `;
  }

  static generateVideoHTML(url) {
    return `
      <div class="regular-media-container">
        <video controls class="regular-media-video">
          <source src="${url}" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
    `;
  }

  static generateYouTubeHTML(videoId) {
    const embedUrl = `https://www.youtube.com/embed/${videoId}`;
    return `
      <div class="regular-media-container">
        <div class="regular-media-youtube-wrapper">
          <iframe src="${embedUrl}" 
                  class="regular-media-youtube-iframe" 
                  frameborder="0" 
                  allowfullscreen>
          </iframe>
        </div>
      </div>
    `;
  }

  static getStyles() {
    return `
      /* Regular Media Styles */
      .rich-text-content .regular-media-container {
        margin: 1.5rem 0 !important;
        padding: 0 !important;
        text-align: center !important;
      }

      .rich-text-content .regular-media-image {
        max-width: 100% !important;
        height: auto !important;
        border-radius: 8px !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
        cursor: pointer !important;
        max-height: 500px !important;
        object-fit: contain !important;
        margin: 0 !important;
        padding: 0 !important;
        display: block !important;
        margin-left: auto !important;
        margin-right: auto !important;
      }

      .rich-text-content .regular-media-video {
        max-width: 100% !important;
        height: auto !important;
        border-radius: 8px !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
        max-height: 400px !important;
        margin: 0 !important;
        padding: 0 !important;
        display: block !important;
        margin-left: auto !important;
        margin-right: auto !important;
      }

      .rich-text-content .regular-media-youtube-wrapper {
        position: relative !important;
        padding-bottom: 56.25% !important;
        height: 0 !important;
        overflow: hidden !important;
        border-radius: 8px !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
        margin: 0 !important;
      }

      .rich-text-content .regular-media-youtube-iframe {
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        width: 100% !important;
        height: 100% !important;
        border-radius: 8px !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      /* Mobile Responsiveness for Regular Media */
      @media (max-width: 768px) {
        .rich-text-content .regular-media-container {
          margin: 1rem 0 !important;
        }

        .rich-text-content .regular-media-image {
          border-radius: 4px !important;
          max-height: 300px !important;
        }

        .rich-text-content .regular-media-video {
          border-radius: 4px !important;
          max-height: 250px !important;
        }

        .rich-text-content .regular-media-youtube-wrapper {
          border-radius: 4px !important;
        }
      }

      @media (max-width: 480px) {
        .rich-text-content .regular-media-container {
          margin: 0.75rem 0 !important;
        }

        .rich-text-content .regular-media-image {
          max-height: 250px !important;
        }

        .rich-text-content .regular-media-video {
          max-height: 200px !important;
        }
      }
    `;
  }
}